import { i18n } from '@boot/i18n';

const UNIT_LABEL_TEMPLATES = {
    hour: { one: 'Last 1 hour', many: 'Last {hours} hours', params: 'hours' },
    day: { one: 'Last 1 day', many: 'Last {days} days', params: 'days' },
    week: { one: 'Last 1 week', many: 'Last {weeks} weeks', params: 'weeks' },
    month: {
        one: 'Last 1 month',
        many: 'Last {months} months',
        params: 'months'
    },
    year: { one: 'Last 1 year' } // Two or more years are not supported
};

/**
 * Returns a localized label like “Last 7 days”.
 *
 * @param {number} windowSize   - Number of units in the range.
 * @param {'hour'|'day'|'week'|'month'|'year'} unit - Time unit.
 * @returns {string} Localised “Last …” label or “-” if unsupported.
 */
export function getAutomaticReportsPeriodLabel(windowSize, unit) {
    if (windowSize < 1) return '-';

    const unitLabelTemplate = UNIT_LABEL_TEMPLATES[unit];
    if (!unitLabelTemplate) return '-';

    const label =
        windowSize === 1 ? unitLabelTemplate.one : unitLabelTemplate.many;
    if (!label) return '-';

    const translationParam =
        windowSize === 1 ? {} : { [unitLabelTemplate.params]: windowSize };

    return i18n.global.t(label, translationParam);
}
